import ModalFooter from "features/shared/components/modal/ModalFooter";
import ModalHeader from "features/shared/components/modal/ModalHeader";
import React from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "features/shared/forms/hooks/useForm";
import FormGroup from "features/shared/forms/components/FormGroup";
import { sipoAccountValidations, validateSipo } from "./sipoAccountValidations";
import CustomerSipoAccountDTO from "features/customer/dtos/CustomerSipoAccountDTO";
import { useTranslation } from "react-i18next";

interface Props {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: (sipo: CustomerSipoAccountDTO) => void;
}

const SipoAccountDialog = ({ show, setShow, onSubmit }: Props) => {
  // translations
  const tLabels = useTranslation("payments\\payments").t;  

  // form hook
  const { values, errors, bindField, clearForm, validateFormField, setValidationError } = useForm({
    initialValidations: sipoAccountValidations(),
  });

  // helpers
  const validateForm = (): boolean => validateSipo(values["sipoNumber"], validateFormField, setValidationError);

  // handlers
  const submitFormHandler = (e: React.FormEvent) => {
    e.preventDefault();

    if (validateForm()) {
      let sipo: CustomerSipoAccountDTO = { ...values };
      onSubmit(sipo);
      clearForm();
    }
  };

  const closeDialogHandler = () => {
    clearForm();
    setShow(false);
  };

  const sipoBlurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
    validateSipo(e.target.value, validateFormField, setValidationError);
  }

  // render
  return (
    <Modal show={show} onHide={closeDialogHandler}>
      <ModalHeader
        title={tLabels("sipoAccountDialog.cardTitle")}
        onCloseClick={closeDialogHandler}
      />
      <form onSubmit={submitFormHandler}>
        <div className="modal-body py-4">
          <FormGroup
            labelText={tLabels("sipoAccountDialog.sipo")}
            validationError={errors["sipoNumber"] ?? undefined}
          >
            <input
              className="form-control"
              placeholder={tLabels("sipoAccountDialog.setSipo")}
              onBlur={sipoBlurHandler}
              {...bindField("sipoNumber")}
            />
          </FormGroup>
        </div>
        <ModalFooter>
          <button type="submit" className="btn btn-primary">
            {tLabels("sipoAccountDialog.add")}
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default SipoAccountDialog;
